import { fetchConToken, fetchSinToken } from "../utils/fetch.ts";


export const modificarContrasena = async (password1:string, password2:string) => {
  try {
    const resp = await fetchConToken("misdatos/actualizar-clave", { password1, password2 }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
};

export const modificarMisDatos = async (nombre:string, apellido:string, email:string, rut?:string, telefono?:string, comuna_id?:number) => {
  try {
    const resp = await fetchConToken("misdatos/actualizar", { nombre, apellido, email, rut, telefono, comuna_id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
};
